module.exports = __webpack_public_path__ + "img/resbg.7140d592.png";